import React from "react";
import "./FixProfileNavbar.css";
import "./ProfileNavbar.css";
import logo from "../../assets/img/logoNew.png";
import { Link } from "react-router-dom";
import { Icon } from "semantic-ui-react";
import { withRouter } from "react-router-dom";
import "./mobileNavBar.scss";
// import DropdownMenu, { NestedDropdownMenu } from 'react-dd-menu';
import "./react-dd-menu.css";
import UserAvatar from "../UserAvatar/UserAvatar";

//Jiazheng: redux store
// import store from "../../redux/store"

import MobileMenu from "./MobileMenu";
import Auth from "../../Auth/Auth";
import InboxIcon from "../MenuBar/InboxIcon";
import NotificationIcon from "../MenuBar/NotificationIcon";

class FirstMobileNavBar extends React.Component {
  constructor(props) {
    super(props);
    this.offset = this.props.offset ? "50px" : "0";
    this.state = {
      isMenuOpen: false,
    };
  }

  btn_jump_profile = (e) => {
    e.preventDefault();
    this.props.history.push("/");
  };

  btn_jump_resume = () => {
    this.props.history.push("/resume");
  };

  btn_jump_admin_allteachers = () => {
    this.props.history.push("/AllTeachers");
  };

  btn_jump_admin_allcolleges = () => {
    this.props.history.push("/AllColleges");
  };

  btn_jump_admin_validatedocs = () => {
    this.props.history.push("/validatedocuments");
  };

  btn_jump_mycalendar = () => {
    this.props.history.push("/MyCalendar");
  };

  btn_jump_joblist = () => {
    this.props.history.push("/Joblist");
  };

  btn_jump_information = () => {
    this.props.history.push("/PersonalDetails");
  };

  btn_jump_emergency = () => {
    this.props.history.push("/EmergencyContact");
  };

  btn_jump_identificationDoc = () => {
    this.props.history.push("/PersonalID");
  };

  btn_jump_visa = () => {
    this.props.history.push("/Visa");
  };

  btn_jump_police_check = () => {
    this.props.history.push("/PoliceCheck");
  };

  btn_jump_wwcc = () => {
    this.props.history.push("/wwcc");
  };

  btn_jump_security = () => {
    this.props.history.push("/");
  };

  btn_jump_payments = () => {
    // this.props.history.push("/payments");
  };

  btn_jump_logout = () => {
    Auth.logout();
    window.localStorage.clear();
    this.props.history.push("/login");
  };

  toggle = () => {
    this.setState({ isMenuOpen: !this.state.isMenuOpen });
  };

  close = () => {
    this.setState({ isMenuOpen: false });
  };

  menuItem = (title, icon, onClick) => {
    return (
      <span className={icon ? `mdi mdi-${icon}` : ""} onClick={onClick}>
        <span className={icon ? "item-icon-inner" : ""}>{title}</span>
      </span>
    );
  };

  render() {
    return (
      <>
        <div
          className="top-fix-navbar row profile-navbar menu__header"
          style={{ top: this.offset }}
        >
          <Link title="Ready Teacher" to="/" onClick={this.btn_jump_profile}>
            {this.props.isTeacherInfo ? (
              <UserAvatar type="navbar" />
            ) : (
              <img src={logo} alt="logo" className="component-home-logo" />
            )}
          </Link>

          <div className="col-md-12 menu-area-container menu-area-container-mobile">
            <div className="menu-area">
              <div className="mt-1">
                {(this.props.isViewAsTeacher && (
                  <InboxIcon role="teacher" />
                )) || <InboxIcon />}
              </div>
              <div className="mt-1">
                {this.props.isViewAsTeacher && <NotificationIcon role="teacher" />}
              </div>
              {this.props.isViewAsTeacher ? (
                <>
                  <Link to="/Dashboard">
                    <Icon
                      name="home"
                      size="large"
                      className="menu-home-icon"
                      title="To Dashboard"
                    />
                  </Link>
                  <ul className="nav nav-pills">
                    <li>
                      <MobileMenu />
                    </li>
                  </ul>
                </>
              ) : null}
            </div>
          </div>
        </div>
      </>
    );
  }
}

const MobileNavBar = withRouter(FirstMobileNavBar);

export default MobileNavBar;
